import type { ReactNode } from 'react';
import { MdKeyboardArrowLeft } from 'react-icons/md';

type MailPanelHeaderProps = {
  onBack: () => void;
  title: ReactNode;
  actions?: ReactNode;
};

export default function MailPanelHeader({ onBack, title, actions }: MailPanelHeaderProps) {
  return (
    <div className="flex w-full items-center justify-between gap-md py-md pr-lg pl-md">
      <div className="flex min-w-0 items-center gap-xs">
        <button
          type="button"
          aria-label="一覧に戻る"
          onClick={onBack}
          className="flex size-[42px] shrink-0 cursor-pointer items-center justify-center rounded-sm border-none bg-transparent p-0 text-primary transition-colors hover:bg-primary_lighten"
        >
          <MdKeyboardArrowLeft className="size-5" />
        </button>
        <div className="flex min-w-0 items-center gap-xs text-heading-xs text-main">{title}</div>
      </div>
      {actions && <div className="flex shrink-0 items-center gap-xs">{actions}</div>}
    </div>
  );
}
